import { render } from "./Snapshots.vue?vue&type=template&id=689ff561"
import script from "./Snapshots.vue?vue&type=script&lang=js"
export * from "./Snapshots.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__